import React from 'react';

import { RoundPressControlComponent } from 'design/roundPressControl';
import { fillStringWithSpaces } from 'utils/stringUtils';
import { writeToClipboard } from 'utils/clipboardUtils';
import { SECOND_MS } from 'utils/constants';
import { TooltipComponent } from 'design/tooltip/tooltipComponents';
import { useIntlDictionary } from 'hooks/useIntlDictionary';

type Props = {
  partnerCode: string;
};

export const CopyPartnerCodeButton = (props: Props) => {
  const { partnerCode } = props;

  const { shared: sharedDictionary } = useIntlDictionary();

  const [hasTooltip, setHasTooltip] = React.useState(false);

  const copyCodeToClipboard = React.useCallback(() => {
    writeToClipboard(partnerCode).then(() => {
      setHasTooltip(true);

      setTimeout(() => {
        setHasTooltip(false);
      }, SECOND_MS * 1);
    });
  }, [partnerCode]);

  return (
    <RoundPressControlComponent onPress={copyCodeToClipboard}>
      {fillStringWithSpaces(partnerCode)}
      <TooltipComponent visible={hasTooltip}>
        {sharedDictionary.partnerCodeTooltipText}
      </TooltipComponent>
    </RoundPressControlComponent>
  );
};
